export const Mehrfachbeschaeftigung = [
  {
    'PAISY Wert': 1,
    Bezeichnung: 'Mehrfachbeschäftigter',
  },
  {
    'PAISY Wert': 2,
    Bezeichnung: 'Aushilfen',
  },
  {
    'PAISY Wert': 3,
    Bezeichnung: 'Aush./Mehrfachbesch.',
  },
  {
    'PAISY Wert': 5,
    Bezeichnung: 'kein Mehrfachbeschäftigter/Versbezug',
  },
  {
    'PAISY Wert': 6,
    Bezeichnung: 'Mehrfachbeschäftigter/Versbezug',
  },
  {
    'PAISY Wert': 0,
    Bezeichnung: 'kein Mehrfachbeschäftigter',
  },
];
